webpackJsonp([39862026607597],{

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech1.a80572f1.jpg";

/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech10.c3c3acf6.jpg";

/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech11.914046bb.jpg";

/***/ }),

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech12.9fd687fc.jpg";

/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech13.8e810b2b.jpg";

/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech14.a7da2491.jpg";

/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech15.fe5ceca4.jpg";

/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech16.7eaeaf3e.jpg";

/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech17.0d671a4d.jpg";

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech18.680ef119.jpg";

/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech19.32f0adb2.jpg";

/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech2.b4162aa4.jpg";

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech20.6849e177.jpg";

/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech21.4f813c73.jpg";

/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech22.d7c5d1ca.jpg";

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech23.89cd48e6.jpg";

/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech24.eeb32af3.jpg";

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech25.30be36ab.jpg";

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech26.0f44bc45.jpg";

/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech27.80fb0450.jpg";

/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech3.5555fb16.jpg";

/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech4.931b9d89.jpg";

/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech5.e54358c2.jpg";

/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech6.09d49d7a.jpg";

/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech7.c2be649c.jpg";

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech8.df822080.jpg";

/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tech9.b876dcb1.jpg";

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Helmet = __webpack_require__(26);
	
	var _Helmet2 = _interopRequireDefault(_Helmet);
	
	var _Section = __webpack_require__(48);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Carousel = __webpack_require__(64);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	var _Button = __webpack_require__(22);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _technika = __webpack_require__(705);
	
	var _technika2 = _interopRequireDefault(_technika);
	
	var _tech = __webpack_require__(673);
	
	var _tech2 = _interopRequireDefault(_tech);
	
	var _tech3 = __webpack_require__(684);
	
	var _tech4 = _interopRequireDefault(_tech3);
	
	var _tech5 = __webpack_require__(693);
	
	var _tech6 = _interopRequireDefault(_tech5);
	
	var _tech7 = __webpack_require__(694);
	
	var _tech8 = _interopRequireDefault(_tech7);
	
	var _tech9 = __webpack_require__(695);
	
	var _tech10 = _interopRequireDefault(_tech9);
	
	var _tech11 = __webpack_require__(696);
	
	var _tech12 = _interopRequireDefault(_tech11);
	
	var _tech13 = __webpack_require__(697);
	
	var _tech14 = _interopRequireDefault(_tech13);
	
	var _tech15 = __webpack_require__(698);
	
	var _tech16 = _interopRequireDefault(_tech15);
	
	var _tech17 = __webpack_require__(699);
	
	var _tech18 = _interopRequireDefault(_tech17);
	
	var _tech19 = __webpack_require__(674);
	
	var _tech20 = _interopRequireDefault(_tech19);
	
	var _tech21 = __webpack_require__(675);
	
	var _tech22 = _interopRequireDefault(_tech21);
	
	var _tech23 = __webpack_require__(676);
	
	var _tech24 = _interopRequireDefault(_tech23);
	
	var _tech25 = __webpack_require__(677);
	
	var _tech26 = _interopRequireDefault(_tech25);
	
	var _tech27 = __webpack_require__(678);
	
	var _tech28 = _interopRequireDefault(_tech27);
	
	var _tech29 = __webpack_require__(679);
	
	var _tech30 = _interopRequireDefault(_tech29);
	
	var _tech31 = __webpack_require__(680);
	
	var _tech32 = _interopRequireDefault(_tech31);
	
	var _tech33 = __webpack_require__(681);
	
	var _tech34 = _interopRequireDefault(_tech33);
	
	var _tech35 = __webpack_require__(682);
	
	var _tech36 = _interopRequireDefault(_tech35);
	
	var _tech37 = __webpack_require__(683);
	
	var _tech38 = _interopRequireDefault(_tech37);
	
	var _tech39 = __webpack_require__(685);
	
	var _tech40 = _interopRequireDefault(_tech39);
	
	var _tech41 = __webpack_require__(686);
	
	var _tech42 = _interopRequireDefault(_tech41);
	
	var _tech43 = __webpack_require__(687);
	
	var _tech44 = _interopRequireDefault(_tech43);
	
	var _tech45 = __webpack_require__(688);
	
	var _tech46 = _interopRequireDefault(_tech45);
	
	var _tech47 = __webpack_require__(689);
	
	var _tech48 = _interopRequireDefault(_tech47);
	
	var _tech49 = __webpack_require__(690);
	
	var _tech50 = _interopRequireDefault(_tech49);
	
	var _tech51 = __webpack_require__(691);
	
	var _tech52 = _interopRequireDefault(_tech51);
	
	var _tech53 = __webpack_require__(692);
	
	var _tech54 = _interopRequireDefault(_tech53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var images = [{ resolutions: { src: _tech2.default } }, { resolutions: { src: _tech4.default } }, { resolutions: { src: _tech6.default } }, { resolutions: { src: _tech8.default } }, { resolutions: { src: _tech10.default } }, { resolutions: { src: _tech12.default } }, { resolutions: { src: _tech14.default } }, { resolutions: { src: _tech16.default } }, { resolutions: { src: _tech18.default } }, { resolutions: { src: _tech20.default } }, { resolutions: { src: _tech22.default } }, { resolutions: { src: _tech24.default } }, { resolutions: { src: _tech26.default } }, { resolutions: { src: _tech28.default } }, { resolutions: { src: _tech30.default } }, { resolutions: { src: _tech32.default } }, { resolutions: { src: _tech34.default } }, { resolutions: { src: _tech36.default } }, { resolutions: { src: _tech38.default } }, { resolutions: { src: _tech40.default } }, { resolutions: { src: _tech42.default } }, { resolutions: { src: _tech44.default } }, { resolutions: { src: _tech46.default } }, { resolutions: { src: _tech48.default } }, { resolutions: { src: _tech50.default } }, { resolutions: { src: _tech52.default } }, { resolutions: { src: _tech54.default } }];
	
	var text = '<p><strong>CustomArt</strong> zapewnia r\xF3wnie\u017C kompleksow\u0105 obs\u0142ug\u0119 techniczn\u0105, pozwalaj\u0105c\u0105 obs\u0142u\u017Cy\u0107 ka\u017Cdy sw\xF3j produkt artystyczny oraz wsp\xF3\u0142pracuje z renomowanymi podwykonawcami techniki estradowej, co pozwala zrealizowa\u0107 profesjonalnie praktycznie ka\u017Cde wydarzenie.</p>';
	var seo = 'CustomArt zapewnia kompleksową obsługę techniczną, pozwalającą obsłużyć każdy swój produkt artystyczny oraz współpracuje z renomowanymi podwykonawcami techniki estradowej, co pozwala zrealizować profesjonalnie praktycznie każde wydarzenie.';
	
	var Tech = function Tech(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Helmet2.default,
	      { title: 'Technika estradowa' },
	      _react2.default.createElement('meta', { type: 'description', content: seo })
	    ),
	    _react2.default.createElement(_Section2.default, {
	      isFirstSection: true,
	      title: 'TECHNIKA ESTRADOWA',
	      background: _technika2.default,
	      subtitle: text
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'section__container', style: { padding: '50px 15px' } },
	      _react2.default.createElement(
	        'p',
	        null,
	        'W ramach podstawowej obs\u0142ugi oferujemy podesty sceniczne w r\xF3\u017Cnych wariantach obicia, pe\u0142ne nag\u0142o\u015Bnienie koncertowe zar\xF3wno dla DJ-\xF3w, jak i rozbudowanych zespo\u0142\xF3w, o\u015Bwietlenie koncertowe oraz architektoniczne. Mo\u017Cemy pochwali\u0107 si\u0119 r\xF3wnie\u017C realizacjami du\u017Cych wydarze\u0144 na kt\xF3rych poza aspektem artystycznym, zapewniali\u015Bmy elementy scenografii, multimedia, czy elementy wyposa\u017Cenia. W zale\u017Cno\u015Bci od potrzeb i skali realizacji zapewniamy pe\u0142n\u0105 obs\u0142ug\u0119 sprz\u0119tu przez pracownik\xF3w technicznych, realizator\xF3w d\u017Awi\u0119ku, \u015Bwiat\u0142a oraz wizji.'
	      )
	    ),
	    _react2.default.createElement(_Carousel2.default, { images: images }),
	    _react2.default.createElement(
	      'div',
	      { className: 'section__container', style: { padding: '100px 15px' } },
	      _react2.default.createElement(
	        'p',
	        null,
	        'W naszej ofercie mo\u017Cna znale\u017A\u0107 mi\u0119dzy innymi:'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Konstrukcje, scenografia i multimedia'
	        )
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'ponad 100 m2 podest\xF3w scenicznych'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'dowolne warianty obicia od klasycznych wyk\u0142adzin po elegancki HIPS'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'ponad 200 mb kratownic i konstrukcji w r\xF3\u017Cnych systemach'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'mo\u017Cliwo\u015B\u0107 wyprodukowania dowolnych zastawek i zabud\xF3w na \u017Cyczenie klienta'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'ekrany bezszwowe'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'diody p3 i p5 r\xF3wnie\u017C outdoor'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'projektory i telewizory LCD'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Nag\u0142o\u015Bnienie'
	        )
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'systemy QSC - KW, KLA'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'systemy L\u2019Acoustics - KARA, ARCS, SB18, X12, X8, 5XT'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'sto\u0142y cyfrowe Behringer, Midas Pro2, Yamaha QL5'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'omikrofonowanie kablowe, bezprzewodowe, r\xF3wnie\u017C nag\u0142owne - Shure, Sennheiser, AKG, EV, Neumann'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'O\u015Bwietlenie'
	        )
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Robe Pointe'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Cheuvet Maverick MK2 Spot'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Cheuvet Maverick MK2 Wash'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'beam'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'point'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'led Par'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'led Bar'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'hazer'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'sto\u0142y Jands Vista, Dot 2, grandMA2'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'center', padding: '30px 0' } },
	      _react2.default.createElement(_Button2.default, { type: 'yellow', label: 'Napisz do nas!', mailto: 'mailto:kontakt@customart.pl' })
	    ),
	    _react2.default.createElement('div', { style: { paddingTop: 100 } })
	  );
	};
	
	exports.default = Tech;
	module.exports = exports['default'];

/***/ }),

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/technika.a59280c1.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-technika-estradowa-js-35405e2741cc47aaa1c6.js